function heroVideoIsVisible(video) {
	if (window.getComputedStyle(video).display === "none") {
		return false;
	}

	return true;
}

function autoplayHeroVideo(video) {
	const animation_allowed = window.matchMedia("(prefers-reduced-motion: no-preference)");

	if (animation_allowed.matches && video.paused) {
		video.play();
	}
}

function setHeroVideoStatePause(video, button, container) {
	var button_label = button.querySelector(".label");

	container.classList.remove("is-playing");
	video.classList.remove("is-playing");
	button.classList.remove("is-playing");

	button.title = button_label.innerText = "Play Background Video";
}

function setHeroVideoStatePlay(video, button, container) {
	var button_label = button.querySelector(".label");

	container.classList.add("is-playing");
	video.classList.add("is-playing");
	button.classList.add("is-playing");

	button.title = button_label.innerText = "Pause Background Video";
}

function setupHeroVideo() {
	const heroes = document.querySelectorAll(".acf-hero.has-video");

	heroes.forEach(function (hero) {
		const video = hero.querySelector(".media video");

		if (typeof video === "object" && video !== null) {
			const button = hero.querySelector(".video-toggle");

			button.addEventListener("click", function () {
				if (video.paused) {
					video.play();
				} else {
					video.pause();
				}
			});
			button.removeAttribute("hidden");

			video.addEventListener("play", function (event) {
				setHeroVideoStatePlay(video, button, hero);
			});
			video.addEventListener("pause", function (event) {
				setHeroVideoStatePause(video, button, hero);
			});

			autoplayHeroVideo(video);
		}
	});

	if ("IntersectionObserver" in window || !!window.IntersectionObserver) {
		var heroObserver = new IntersectionObserver(
			function (elements, observer) {
				elements.forEach(function (element) {
					const video = element.target;
					if (element.isIntersecting) {
						if (video.paused && video.hasAttribute("data-resume-scroll") && heroVideoIsVisible(video)) {
							video.play();
							video.removeAttribute("data-resume-scroll");
						}
					} else {
						if (!video.paused) {
							video.setAttribute("data-resume-scroll", "true");
							video.pause();
						}
					}
				});
			},
			{ threshold: 0.75 }
		);

		heroes.forEach(function (hero) {
			const video = hero.querySelector("video");
			if (video) {
				// video.setAttribute("data-reveal", "active");
				heroObserver.observe(video);
			}
		});
	}
}

if (typeof window.matchMedia == "function") {
	setupHeroVideo();
}
